import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getExternalReferrersRes: null,
    getExternalReferrerRes: null,
    createExternalReferrerRes: null,
    updateExternalReferrerRes: null,
    deleteExternalReferrerRes: null,
    assignOrderRes: null,
    revokeOrderRes: null,
    getAssignedOrdersRes: null,
    searchOrdersRes: null,
    // External portal state
    myOrdersRes: null,
    orderDetailRes: null,
    orderReportRes: null,
};

const slice = createSlice({
    name: 'externalReferrer',
    initialState,
    reducers: {
        // List external referrers
        getExternalReferrersRequest: (state) => {
            state.loading = true;
        },
        getExternalReferrersSuccess: (state, action) => {
            state.loading = false;
            state.getExternalReferrersRes = action.payload;
        },
        getExternalReferrersFailure: (state, action) => {
            state.loading = false;
            state.getExternalReferrersRes = action.payload;
        },
        resetGetExternalReferrers: (state) => {
            state.getExternalReferrersRes = null;
        },

        // Get single external referrer
        getExternalReferrerRequest: (state) => {
            state.loading = true;
        },
        getExternalReferrerSuccess: (state, action) => {
            state.loading = false;
            state.getExternalReferrerRes = action.payload;
        },
        getExternalReferrerFailure: (state, action) => {
            state.loading = false;
            state.getExternalReferrerRes = action.payload;
        },
        resetGetExternalReferrer: (state) => {
            state.getExternalReferrerRes = null;
        },

        // Create external referrer
        createExternalReferrerRequest: (state) => {
            state.loading = true;
        },
        createExternalReferrerSuccess: (state, action) => {
            state.loading = false;
            state.createExternalReferrerRes = action.payload;
        },
        createExternalReferrerFailure: (state, action) => {
            state.loading = false;
            state.createExternalReferrerRes = action.payload;
        },
        resetCreateExternalReferrer: (state) => {
            state.createExternalReferrerRes = null;
        },

        // Update external referrer
        updateExternalReferrerRequest: (state) => {
            state.loading = true;
        },
        updateExternalReferrerSuccess: (state, action) => {
            state.loading = false;
            state.updateExternalReferrerRes = action.payload;
        },
        updateExternalReferrerFailure: (state, action) => {
            state.loading = false;
            state.updateExternalReferrerRes = action.payload;
        },
        resetUpdateExternalReferrer: (state) => {
            state.updateExternalReferrerRes = null;
        },

        // Delete external referrer
        deleteExternalReferrerRequest: (state) => {
            state.loading = true;
        },
        deleteExternalReferrerSuccess: (state, action) => {
            state.loading = false;
            state.deleteExternalReferrerRes = action.payload;
        },
        deleteExternalReferrerFailure: (state, action) => {
            state.loading = false;
            state.deleteExternalReferrerRes = action.payload;
        },
        resetDeleteExternalReferrer: (state) => {
            state.deleteExternalReferrerRes = null;
        },

        // Assign order to external referrer
        assignOrderRequest: (state) => {
            state.loading = true;
        },
        assignOrderSuccess: (state, action) => {
            state.loading = false;
            state.assignOrderRes = action.payload;
        },
        assignOrderFailure: (state, action) => {
            state.loading = false;
            state.assignOrderRes = action.payload;
        },
        resetAssignOrder: (state) => {
            state.assignOrderRes = null;
        },

        // Revoke order access
        revokeOrderRequest: (state) => {
            state.loading = true;
        },
        revokeOrderSuccess: (state, action) => {
            state.loading = false;
            state.revokeOrderRes = action.payload;
        },
        revokeOrderFailure: (state, action) => {
            state.loading = false;
            state.revokeOrderRes = action.payload;
        },
        resetRevokeOrder: (state) => {
            state.revokeOrderRes = null;
        },

        // Get assigned orders for external referrer
        getAssignedOrdersRequest: (state) => {
            state.loading = true;
        },
        getAssignedOrdersSuccess: (state, action) => {
            state.loading = false;
            state.getAssignedOrdersRes = action.payload;
        },
        getAssignedOrdersFailure: (state, action) => {
            state.loading = false;
            state.getAssignedOrdersRes = action.payload;
        },
        resetGetAssignedOrders: (state) => {
            state.getAssignedOrdersRes = null;
        },

        // Search orders for assignment
        searchOrdersRequest: (state) => {
            state.loading = true;
        },
        searchOrdersSuccess: (state, action) => {
            state.loading = false;
            state.searchOrdersRes = action.payload;
        },
        searchOrdersFailure: (state, action) => {
            state.loading = false;
            state.searchOrdersRes = action.payload;
        },
        resetSearchOrders: (state) => {
            state.searchOrdersRes = null;
        },

        // ==================== External Portal Actions ====================

        // Get my assigned orders (external user)
        getMyOrdersRequest: (state) => {
            state.loading = true;
        },
        getMyOrdersSuccess: (state, action) => {
            state.loading = false;
            state.myOrdersRes = action.payload;
        },
        getMyOrdersFailure: (state, action) => {
            state.loading = false;
            state.myOrdersRes = action.payload;
        },
        resetGetMyOrders: (state) => {
            state.myOrdersRes = null;
        },

        // Get order detail (external user)
        getOrderDetailRequest: (state) => {
            state.loading = true;
        },
        getOrderDetailSuccess: (state, action) => {
            state.loading = false;
            state.orderDetailRes = action.payload;
        },
        getOrderDetailFailure: (state, action) => {
            state.loading = false;
            state.orderDetailRes = action.payload;
        },
        resetGetOrderDetail: (state) => {
            state.orderDetailRes = null;
        },

        // Get order report (external user)
        getOrderReportRequest: (state) => {
            state.loading = true;
        },
        getOrderReportSuccess: (state, action) => {
            state.loading = false;
            state.orderReportRes = action.payload;
        },
        getOrderReportFailure: (state, action) => {
            state.loading = false;
            state.orderReportRes = action.payload;
        },
        resetGetOrderReport: (state) => {
            state.orderReportRes = null;
        },
    }
});

export const {
    getExternalReferrersRequest,
    getExternalReferrersSuccess,
    getExternalReferrersFailure,
    resetGetExternalReferrers,
    getExternalReferrerRequest,
    getExternalReferrerSuccess,
    getExternalReferrerFailure,
    resetGetExternalReferrer,
    createExternalReferrerRequest,
    createExternalReferrerSuccess,
    createExternalReferrerFailure,
    resetCreateExternalReferrer,
    updateExternalReferrerRequest,
    updateExternalReferrerSuccess,
    updateExternalReferrerFailure,
    resetUpdateExternalReferrer,
    deleteExternalReferrerRequest,
    deleteExternalReferrerSuccess,
    deleteExternalReferrerFailure,
    resetDeleteExternalReferrer,
    assignOrderRequest,
    assignOrderSuccess,
    assignOrderFailure,
    resetAssignOrder,
    revokeOrderRequest,
    revokeOrderSuccess,
    revokeOrderFailure,
    resetRevokeOrder,
    getAssignedOrdersRequest,
    getAssignedOrdersSuccess,
    getAssignedOrdersFailure,
    resetGetAssignedOrders,
    searchOrdersRequest,
    searchOrdersSuccess,
    searchOrdersFailure,
    resetSearchOrders,
    getMyOrdersRequest,
    getMyOrdersSuccess,
    getMyOrdersFailure,
    resetGetMyOrders,
    getOrderDetailRequest,
    getOrderDetailSuccess,
    getOrderDetailFailure,
    resetGetOrderDetail,
    getOrderReportRequest,
    getOrderReportSuccess,
    getOrderReportFailure,
    resetGetOrderReport,
} = slice.actions;

export default slice.reducer;
